import { createSelector } from 'reselect';

export const appGetDataState = ({ app }) => app.data;
export const appGetWork = ({ app }) => app.data.work;
export const appGetCurrentId = ({ app }) => app.currentId;

export const appGetItemFromId = (props) => createSelector(
  [appGetWork],
  (work) => {
    const id = props.match.params.id;
    return work.find(item => item.id.toLowerCase().indexOf(id) !== -1) || work[0];
  }
);



// WEBPACK FOOTER //
// ./src/selectors/index.js